import ky from "@/i18n/ky";
import ru from "@/i18n/ru";
import az from "@/i18n/az";
import uz from "@/i18n/uz";
import tg from "@/i18n/tg";

export const LANG = Object.freeze({
    KY: {
        CODE: "ky",
        NAME: "Кыргызча"
    },
    RU: {
        CODE: "ru",
        NAME: "Русский"
    },
    UZ: {
        CODE: "uz",
        NAME: "O'zbekcha"
    },
    /*AZ: {
        CODE: "az",
        NAME: "Azeri"
    },*/
    TG: {
        CODE: "tg",
        NAME: "Точикй"
    },
});

export default {
    locale: LANG.RU.CODE,
    fallbackLocale: LANG.RU.CODE,
    messages: {
        ky: ky,
        ru: ru,
        uz: uz,
        az: az,
        tg: tg,
    }
};